import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import { PICKER_SLUG, ADMIN_SLUG } from "./config";
import Leaderboard from "./pages/Leaderboard.vue";
import Picker from "./pages/Picker.vue";
import Admin from "./pages/Admin.vue";

const routes: RouteRecordRaw[] = [
  { path: "/", name: "leaderboard", component: Leaderboard },
  { path: `/picker-${PICKER_SLUG}`, name: "picker", component: Picker },
  { path: `/admin-${ADMIN_SLUG}`, name: "admin", component: Admin },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

export const router = createRouter({ history: createWebHistory(), routes });
